import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

import { Image } from '@utils/cook/types'

import ResponsiveImageV2 from '@components/ResponsiveImageV2'
import { ImageRatios, ImageWidths } from '@components/ResponsiveImageV2/types'

export interface BackgroundImageProps {
  image: Image<'16_9'>
  className?: string
  children?: ReactNode
}

const RATIOS = {
  desktop: '16_9',
  tablet: '16_9',
  mobile: '16_9',
} as const satisfies ImageRatios

const WIDTHS = {
  desktop: 964,
  tablet: 632,
  mobile: 'viewport-width',
} as const satisfies ImageWidths

const StyledResponsiveImageV2 = styled(ResponsiveImageV2)`
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(180deg, #3b3b3b 0%, #5e5d5d 100%);
`

const BackgroundImage: FunctionComponent<BackgroundImageProps> = ({
  className,
  image,
  children,
}) => {
  return (
    <>
      <StyledResponsiveImageV2
        src={image?.src}
        alt={image?.alt}
        crops={image?.crops ?? {}}
        ratios={RATIOS}
        widths={WIDTHS}
        className={className}
      />
      {children}
    </>
  )
}

export default BackgroundImage
